import React from 'react'
import { Space, Image, Tag } from 'antd'
import { Wrapper, Actions, StyledButton } from './ArcAd.styles'

// Status color mapping
const getStatusColor = (status, isExpired) => {
  if (isExpired) return 'red' // Expired takes precedence

  switch (status) {
    case 'active': return 'green' // Active
    case 'paused': return 'orange' // Paused
    case 'not_opened': return 'default' // Not Opened
    default: return 'default'
  }
}

export const getColumns = (handleEditAd, handleDeleteAd) => [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: true,
      width: 80,
    },
    {
      title: 'Hero',
      key: 'hero_url',
      width: 120,
      render: (_, record) => (
        <Space direction="vertical" size="small">
          {record.icon_url && (
            <Image
              width={40}
              height={40}
              src={record.icon_url}
              alt="Icon"
              style={{ borderRadius: 4, border: '1px solid #f0f0f0' }}
            />
          )}
          {record.hero_url && (
            <Image
              width={40}
              height={30}
              src={record.hero_url}
              alt="Hero"
              style={{ borderRadius: 4, border: '1px solid #f0f0f0' }}
            />
          )}
        </Space>
      ),
    },
    {
      title: 'Header',
      dataIndex: 'header',
      key: 'header',
      sorter: true,
      ellipsis: true,
      width: 200,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      sorter: true,
      render: (status, record) => {
        const displayStatus = record.isExpired ? 'Expired' : (status || 'N/A')
        return (
          <Tag color={getStatusColor(status, record.isExpired)}>
            {displayStatus}
          </Tag>
        )
      }
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
      width: 200,
    },
    {
      title: 'Advertiser',
      dataIndex: 'advertiser_name',
      key: 'advertiser_name',
      width: 150,
      render: (text) => text || 'N/A'
    },
    {
      title: 'Started At',
      dataIndex: 'started_at',
      key: 'started_at',
      sorter: true,
      width: 180,
    },
    {
      title: 'End At',
      dataIndex: 'end_at',
      key: 'end_at',
      sorter: true,
      width: 180,
    },
    {
      title: 'Created Date',
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      width: 180,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 170,
      render: (_, record) => {
        const onEdit = () => handleEditAd(record)
        const onDelete = () => handleDeleteAd(record)
        return (
          <Actions>
            <StyledButton onClick={onEdit}>Edit</StyledButton>
            <StyledButton danger onClick={onDelete}>Delete</StyledButton>
          </Actions>
        )
      },
    },
  ]